<template>
  <custom-dialog
    width="1280px"
    class="accounts-receivable-dialog"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    :title="model.title"
  >
    <div class="dialog-body">
      <!-- <div class="item-title">{{ $t('page__yfyjxx') }}</div> -->
      <div class="table-bd">
        <custom-table
          :data="listData"
          tableCode="deposit_refund_select"
          type="checkbox"
          v-model="selectList"
          @filter="filterChange"
          @sort="sortChange"
        ></custom-table>
      </div>
      <div class="table-page">
        <custom-page
          :total="totalRows"
          :page="formSearch.pageNum"
          :size="formSearch.pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';

// 分页
function paging(arr, pageNum, pageSize) {
  const start = (pageNum - 1) * pageSize;
  return [...arr].splice(start, pageSize);
}

export default {
  name: '',
  mixins: [dialogMixins],
  data() {
    return {
      tableList: [],
      listData: [],
      selectList: [],
      formSearch: {
        pageNum: 1,
        pageSize: 20,
      },
      totalRows: null
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    onPageChange(data) {
      this.formSearch.pageNum = data.page;
      this.formSearch.pageSize = data.size;
      const list = this.tableList;
      const listData = paging(list, data.page, data.size);
      this.listData = listData;
    },
    getTableList() {
      this.$getJSON(apis.DepositRefundList, {
        payableOrgId: this.model.data.payableOrgId,
        receivableOrgId: this.model.data.receivableOrgId,
        existBillIds: this.model.data.existBillIds
      }).then((res) => {
        const {
          pageNum,
          pageSize
        } = this.formSearch;
        const list = res.data;
        const listData = paging(list, pageNum, pageSize);
        this.tableList = list;
        this.listData = listData;
        this.totalRows = list.length;
      });
    },
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    onConfirm() {
      this.closeDialog();
      this.$emit('confirm', this.selectList);
    }
  }
};
</script>

<style></style>
